module.exports = __webpack_public_path__ + "static/img/triumph.2ad5338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/triumph.png
// module id = fdL8
// module chunks = 0